import type { EntitlementCatalog } from './interface';

export const emptyEntitlementCatalog: EntitlementCatalog = {
    Plans: [],
    Addons: [],
};
